import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { type CSSProperties } from 'react';

import { COLOR, SPACING } from '../../theme/tokens';
import { ISortableListItem } from './types';

export function Item({
  record,
  id,
  ItemTemplate,
}: {
  record: ISortableListItem;
  id: UniqueIdentifier;
  ItemTemplate: ({
    id,
    record,
  }: {
    id: UniqueIdentifier;
    record: ISortableListItem;
  }) => React.ReactElement;
}): React.ReactElement {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const itemStyle: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: SPACING.xs,
    border: `1px solid ${COLOR.borderDefault}`,
    borderRadius: 6,
    marginBottom: SPACING.xs,
    userSelect: 'none',
    cursor: 'grab',
    boxSizing: 'border-box',
  };

  return (
    <div style={itemStyle} ref={setNodeRef} {...attributes} {...listeners}>
      <ItemTemplate id={id} record={record} />
    </div>
  );
}
